const isBlobURL = (url: string): boolean => {
  return url.search("blob:") === 0;
};

export default isBlobURL;
